import { Answer } from '@verv-inc/js-questionnaire';
import { ISelectQuestion } from 'modules/survey/interfaces';

export const getAnswer = (
	question: ISelectQuestion,
	value?: string,
	isSelected?: boolean,
): Answer | undefined => {
	const { answer, onlyOneAnswer } = question;

	if (!isSelected) {
		return Array.isArray(answer) ? answer.filter(item => item !== value) : undefined;
	}
	if (value === 'none') {
		return [value];
	}
	if (onlyOneAnswer && value) {
		return [value];
	}
	if (answer != null && value) {
		const answerArr = Array.isArray(answer) ? [...answer, value] : [answer, value];
		return answerArr.filter(value => value !== 'none');
	}
	return value ? [value] : undefined;
};
